import { translation } from '@/plugins/i18n';

const needParseErrorCodeMap = {
  general_error: 380001,
  expire_partner: 380002,
  with_partner: 380003,
};

const preciseMsgMapping = new Map([
  [needParseErrorCodeMap.with_partner, 'billing.coupon.error.with_partner'],
]);

export class PartnerErrorHandler {
  constructor(partnerResult = {}) {
    this.partnerResult = partnerResult;
  }

  formatWithPartner() {
    const { partnerName = '' } = this.partnerResult;
    return translation(preciseMsgMapping.get(needParseErrorCodeMap.with_partner), [partnerName]);
  }

  getErrorMsgWithErrorCode() {
    const { errorCode = '', errorMessage = '' } = this.partnerResult;

    switch (errorCode) {
      case needParseErrorCodeMap.general_error:
        return errorMessage;
      case needParseErrorCodeMap.with_partner:
        return this.formatWithPartner();
      case needParseErrorCodeMap.expire_partner:
        return errorMessage;
      default:
        return '';
    }
  }
}
